﻿import { SwitchProps } from 'antd';
import { FormItemProps } from 'antd/es/form/FormItem';
import { CSSProperties } from 'react';

export const style: CSSProperties = {
    width: '100%'
}

export const switchProps: SwitchProps = {
    style: { minWidth: 65 },
    checkedChildren: "Show",
    unCheckedChildren: "Hide"
}

export const switchFormItemProps: FormItemProps = {
    labelCol: { flex: `0 1 125px` },
}